module.exports = __webpack_public_path__ + "img/skip-enabled.bdc84626.svg";